import React, { useState } from "react";
import Seo from "components/Seo/Seo";
import cursosData from "../data/cursos.json";
import HeroCursos from "components/hero/HeroCursos";
import CardCursosPage from "components/Cards/CardCursosPage";
import CardInfo from "components/Cards/CardInfo";

function Cursos() {
  const preguntasFrecuentes = [
    {
      question:
        "¿Necesito tener conocimientos previos para iniciar el curso de inglés?",
      answer:
        "No es necesario. Contamos con cursos desde nivel básico (A1) hasta avanzado (C2). Además, realizamos una prueba de nivel para ubicarte en el grupo ideal según tus conocimientos actuales.",
    },
    {
      question: "¿Cuánto tiempo dura cada nivel de inglés?",
      answer:
        "La duración depende de la intensidad horaria y del curso de inglés elegido. En promedio, cada nivel puede durar entre 4 y 5 meses.",
    },
    {
      question: "¿Qué horarios tienen disponibles?",
      answer:
        "Ofrecemos horarios en la mañana, tarde, noche y fines de semana para adaptarnos a estudiantes, trabajadores y niños.",
    },
    {
      question: "¿Las clases son presenciales o virtuales?",
      answer:
        "Sabemos que la forma de aprender inglés ha evolucionado, por eso contamos con clases presenciales y también con modalidad virtual en vivo, diseñada para quienes buscan mayor flexibilidad. La apertura de grupos virtuales está sujeta a la cantidad de estudiantes interesados. Solo necesitas una conexión estable a internet, un dispositivo para conectarte y toda la disposición para aprender con nosotros.",
    },
    {
      question: "¿Cómo es el proceso de inscripción?",
      answer:
        "El proceso es rápido y sencillo: diligencias el formulario, realizas una prueba de diagnostico si lo deseas y eliges el horario que se ajuste a tu disponibilidad. Nuestro equipo te acompañará durante todo el proceso.",
    },
  ];
  const razones = [
    {
      razon: "Comunicación Eficaz",
      info: "En Brighton fomentamos tu capacidad para expresarte con confianza y precisión en entornos cotidianos, académicos y profesionales.",
      icon: "comunicacion",
    },
    {
      razon: "Potencia Tus Habilidades",
      info: "Perfeccionaras competencias como comprensión auditiva, expresión oral, lectura y escritura, gracias a nuestra metodología didactica.",
      icon: "habilidades",
    },
    {
      razon: "Aplicación Práctica",
      info: "Te proporcionamos herramientas y estrategias que te permitan utilizar el inglés de manera efectiva en contextos reales.",
      icon: "aplicacion",
    },
    {
      razon: "Resultados Medibles",
      info: "Aprende, demuestra y vive el inglés en situaciones reales, a través de practicas conversacionales, salidas en cotexto, retos interactivos y evaluaciones segun tu nivel.",
      icon: "resultados",
    },
  ];

  const tags = [
    "Todos",
    "Niñas y Niños",
    "Jovenes",
    "Adultos",
    "Curso de Inglés",
    "Certificación oficial",
  ];
  const IconComunicaicon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-bubble-text"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M7 10h10" />
      <path d="M9 14h5" />
      <path d="M12.4 3a5.34 5.34 0 0 1 4.906 3.239a5.333 5.333 0 0 1 -1.195 10.6a4.26 4.26 0 0 1 -5.28 1.863l-3.831 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.33 5.33 0 0 1 4.287 -2.16" />
    </svg>
  );
  const IconHabilidades = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-bulb"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
      <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
      <path d="M9.7 17l4.6 0" />
    </svg>
  );
  const IconAplicacion = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-target-arrow"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M12 7a5 5 0 1 0 5 5" />
      <path d="M13 3.055a9 9 0 1 0 7.941 7.945" />
      <path d="M15 6v3h3l3 -3h-3v-3l-3 3" />
      <path d="M15 9l-3 3" />
    </svg>
  );

  const IconResultados = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-trophy"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8 21l8 0" />
      <path d="M12 17l0 4" />
      <path d="M7 4l10 0" />
      <path d="M17 4v8a5 5 0 0 1 -10 0v-8" />
      <path d="M3 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
    </svg>
  );
  const icons = {
    comunicacion: <IconComunicaicon />,
    habilidades: <IconHabilidades />,
    aplicacion: <IconAplicacion />,
    resultados: <IconResultados />,
  };

  const [filters, setFilters] = useState(["Todos"]);
  const [search, setSearch] = useState("");
  //handle filters
  const handleSearchBar = (e) => {
    setSearch(e.target.value);
  };

  const handleFilters = (e) => {
    if (e.target.value === "Todos") {
      setFilters(["Todos"]);
      return;
    }
    setFilters((prev) => {
      let updateFilters = prev.filter((item) => item !== "Todos");
      if (updateFilters.includes(e.target.value)) {
        updateFilters = updateFilters.filter((item) => item !== e.target.value);
      } else {
        updateFilters.push(e.target.value);
      }
      if (updateFilters.length === 0) {
        return ["Todos"];
      }
      return updateFilters;
    });
  };
  const filteredCursos = cursosData.filter((curso, index) => {
    if (curso.tag.some((tag) => filters.includes(tag))) {
      return <CardCursosPage key={index} curso={curso} />;
    }
    return false
  });
  const filteredBySearch = cursosData.filter((curso) => {
    return (
      curso.descripcion.toLowerCase().includes(search.toLowerCase()) ||
      curso.tag.some((tag) =>
        tag.toLowerCase().includes(search.toLocaleLowerCase()),
      ) ||
      curso.titulo.toLowerCase().includes(search.toLocaleLowerCase())
    );
  });
  
  const FilteredCursos = ({ data, filters, search }) => {
    if (
      search.length > 0
    ) {
      return filteredBySearch.map((curso, index) => (
        <CardCursosPage key={index} curso={curso} />
      ));
    } else if (filters.length > 0 && !filters.includes("Todos")) {
      return filteredCursos.map((curso, index) => (
        <CardCursosPage key={index} curso={curso} />
      ));
    } else {
      return data.map((curso, index) => (
        <CardCursosPage key={index} curso={curso} />
      ));
    }
    // if (filters.includes("Todos") || filters.length === 0) {
    //   return data.map((curso, index) => (
    //     search? <CardCursosPage key={index} curso={curso} /> : <CardCursosPage key={index} curso={curso} />
    //   ));
    // } else {
    //   return filteredCursos.map((curso,index)=>(
    //     <CardCursosPage key={index} curso={curso} />
    //   ))
    // }
  };

  return (
    <>
      <Seo
        title="Cursos de Inglés"
        description="En Brighton encontrarás los cursos perfectos para desarrollar tus habilidades en inglés, trabajar competencias específicas o entrenamientos para certificar tu conocimiento en el idioma."
      />
      <HeroCursos sectionLink="/cursos#info" />
      <section className="min-h-screen" id="info">
        <div className="w-full px-8 py-12 flex flex-col justify-center items-center gap-4">
          <p className="text-primario text-2xl font-bold w-full md:w-2/3 text-center hyphens-none">
            Encuentra el camino ideal hacia la fluidez con nuestra metodologia
            innovadora. Diseñada para todas las edades y niveles profesionales.
          </p>
          <div className="flex flex-wrap justify-center">
            {tags.map((tag, index) => (
              <button
                key={index}
                className={`px-4 py-2 bg-gray-300 ${filters.includes(tag) ? "bg-secundario" : ""} text-primario font-bold rounded-full mx-1 my-2`}
                onClick={handleFilters}
                value={tag}
              >
                {tag}
              </button>
            ))}
          </div>
          <input
            type="text"
            className="px-4 py-2 outline outline-1 outline-gray-400 w-full md:w-2/3 rounded-lg shadow-lg flex flex-row"
            onChange={handleSearchBar}
            placeholder="Curso de inglés, niños y niñas, certificación oficial..."
          />
        </div>
        <div className="p-5 md:p-14 lg:p-20 bg-gray-200 min-h-screen grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-5">
          <FilteredCursos data={cursosData} filters={filters} search={search} />
        </div>
      </section>
      <section className="p-5 md:p-14 lg:px-20 py-24 flex flex-col items-center justify-center gap-16 ">
        <h2 className="text-5xl font-bold text-primario">
          ¿Por qué estudiar en Brighton?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 2xl: gap-6">
          {razones.map((value, index) => (
            <CardInfo title={value.razon} description={value.info} key={index}>
              {icons[value.icon] || null}
            </CardInfo>
          ))}
        </div>
      </section>
      <section className="px-8 py-12 flex flex-col items-center justify-center gap-16 ">
        <h2 className="text-5xl font-bold text-primario">
          Preguntas Frecuentes
        </h2>
        <div className="flex flex-col gap-4 items-center">
          {preguntasFrecuentes.map((item, index) => (
            <details
              key={index}
              className="group bg-gray-300 p-4 w-full md:w-2/3 xl:w-[800px] rounded-lg"
              name="questions"
              
            >
              <summary className="flex justify-between items-center cursor-pointer list-none font-bold text-xl text-primario">
                <span className="w-4/5">{item.question}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down transition-transform group-open:rotate-180 duration-300 ease-in-out"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M6 9l6 6l6 -6" />
                </svg>
              </summary>
              <p className="mt-4">{item.answer}</p>
            </details>
          ))}
        </div>
      </section>
      {/* <div className="w-full text-left hyphens-auto ">
        <Header
          titulo="Cursos de Inglés"
          classTitulo=" text-sky-200"
          classInfo="text-white"
          info="En Brighton encontrarás los cursos perfectos para desarrollar tus habilidades en inglés, trabajar competencias específicas o entrenamientos para certificar tu conocimiento en el idioma."
          linkToSection="/cursos#info"
          botonDescripcion="Mas Información"
          classBoton="text-primario bg-sky-200 hover:bg-blue-800 hover:bg-blue-600"
          img="https://brightonenglishcenter.edu.co/img/DSC_0010.jpg"
        />
        <section
          className=" flex flex-col gap-5 m-20 xl:m-40 rounded-30 items-center bg-blue-6"
          id="info"
        >
          <div className="w-full xl:w-3/4 text-left flex flex-col gap-5 items-center space-y-5">
            <h2 className="text-7xl font-bold text-blue-4 font-Bebas ">
              Nos enfocamos en
            </h2>
            <p className="text-xl xl:text-2xl hyphens-none">
              Nuestros cursos están diseñados para que los estudiantes puedan
              desarrollar de manera efectiva las competencias lingüísticas en
              contextos prácticos. Consideramos el nivel de competencia de cada
              estudiante, estableciendo objetivos reales, específicos y
              funcionales que permiten el desarrollo integral de todas las
              habilidades lingüísticas.
            </p>
          </div>
          <div className="w-full xl:w-3/4 flex flex-col gap-5 items-center">
            <div className="grid grid-cols-2 gap-5 ">
              {razones.map((value, index) => (
                <WhyCard
                  key={index}
                  titulo={value.razon}
                  descripcion={value.info}
                  colorPrimario="#fffbeb"
                  shadowColor="#0d2334"
                />
              ))}
            </div>
          </div>
        </section>
        <section className=" bg-blue-200 rounded-30">
          <div className="py-20 xl:p-40 space-y-10">
            <div className="w-3/4 flex flex-col items-center gap-5 mx-auto">
              <h2 className="text-7xl font-bold text-blue-4 font-Bebas text-center">
                Encuentra el curso de inglés ideal para ti.
              </h2>
              <p className="text-xl xl:text-2xl text-center">
                En Brighton encontraras una serie de cursos pensados en
                desarrollar y afianzar todas las habilidades del idioma de
                manera integral, en contextos reales y aplicando metodologías
                dinámicas.
              </p>
            </div>
            <Carrusel items={itemsCursos} />
          </div>
        </section>
        <section className=" flex flex-col gap-5 m-20 mx-0 xl:m-40">
          <div className="w-4/5 flex flex-col gap-5 max-w-6xl mx-auto">
            <h2 className="text-7xl font-bold text-blue-4 font-Bebas">
              Certifica tu inglés y amplia tus horizontes.
            </h2>
            <p className="text-xl hyphens-none xl:text-2xl">
              Nuestros cursos de preparación para exámenes internacionales están
              diseñados para equiparte con las habilidades y la confianza
              necesarias para destacar en estas pruebas cruciales. Ofrecemos
              programas especializados para una variedad de exámenes reconocidos
              mundialmente como <strong>IELTS, TOEFL, OOPT Y APTIS.</strong>
            </p>
          </div>
          <Carrusel items={itemsExamenes} />
        </section>
        <CarruselVertical
          outputA="40%"
          outputB="-40%"
          title="Nos basamos en el CEFR para garantizar una excelente formación"
          info="Hemos diseñado un programa de formación con el objetivo de cumplir
            los requerimientos del CEFR (Marco Común Europeo de Referencia) para
            brindarle a nuestros estudiantes educación de calidad."
          // link="https://brightonenglishcenter.edu.co/img/tabla_programa_adultos.png"
        >
          <NivelesCard
            color={`#ff7202`}
            nivel="Nivel Elementary (A1)"
            info="Este nivel es ideal para quienes están comenzando desde cero.
                Está dividido en 4 ciclos de 1 mes cada uno. Al finalizar,
                habrás adquirido las habilidades necesarias para entender y usar
                expresiones cotidianas y frases básicas."
          />
          <NivelesCard
            color={`#FFE500`}
            nivel="Nivel Pre-Intermediate (A2)"
            info="Si ya tienes alguna base, este nivel te ayudará a consolidar tus conocimientos. Está dividido en 5 ciclos de 1 mes cada uno. En el último ciclo, te prepararemos para presentar el examen KET (Key English Test), una certificación reconocida que verificará si tu nivel de inglés está bajo el estándar internacional."
          />
          <NivelesCard
            color={`#71DD06`}
            nivel="Nivel Intermediate (B1)"
            info="Este nivel te ayudará a consolidar tus conocimientos. Está dividido en 5 ciclos de 1 mes cada uno. En el último ciclo, te prepararemos para presentar el examen APTIS General, una certificación de British Council reconocida por el Ministerio Educación. Es aceptada en varios contextos académicos y laborales  del país e internacionales."
          />
          <NivelesCard
            color={`#00b1c9`}
            nivel="Nivel Upper-Intermediate (B2)"
            info="Aquí trabajarás en mejorar tu fluidez y precisión del idioma en un entorno más académico. Este nivel también tiene 5 ciclos de 1 mes cada uno, durante este tiempo te prepararemos para presentar la prueba OOPT (Oxford Online Placement Test). Al finalizar, tendrás la oportunidad de certificar tu inglés con exámenes internacionales como IELTS, TOEFL IBT o APTIS Advanced, que son reconocidos en todo el mundo."
          />
          <NivelesCard
            color={`#0049ff`}
            nivel="Nivel Advanced (C1)"
            info="Este nivel está dirigido a quienes desean alcanzar un alto nivel de competencia en inglés. Está dividido en 4 ciclos de 2 meses cada uno, con una duración total de 8 meses. Requiere conocimientos previos sólidos en el idioma."
          />
          <NivelesCard
            color={`#b100e1`}
            nivel="Nivel Upper-Advanced (C2)"
            info="Este es el nivel más avanzado que ofrecemos, ideal para quienes buscan dominar el inglés casi a nivel nativo. Al igual que el nivel C1, consta de 4 ciclos de 2 meses cada uno, con una duración total de 8 meses. Al finalizar, tendrás la oportunidad de certificar tu nivel con exámenes internacionales como IELTS, TOEFL IBT o APTIS Advanced."
          />
        </CarruselVertical>
        <section className="w-full">
          <TestimonialsMarquee />
        </section>
      </div> */}
    </>
  );
}

export default Cursos;
